import * as React from "react";
import {Fragment} from "react";

class SideBar extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {children, position} = this.props;

		return (
			<Fragment>
				<div className={`sidebar${position === 'right' ? ' position-right' : ''}`}>
					{children}
				</div>
			</Fragment>
		);
	}
}

export default SideBar;
